import React from 'react';
import { Container, Mark, TextContainer } from './styles';

export const AttentionBallon: React.FC<{ text: string }> = ({ text }) => (
  <Container>
    <Mark>!</Mark>
    <TextContainer>{text}</TextContainer>
  </Container>
);
